import { supabase } from '@/integrations/supabase/client';

type RpcTriagem = (
  fn: string,
  args: Record<string, unknown>,
) => Promise<{ data: unknown; error: { message?: string; code?: string } | null }>;

/**
 * RPC das triagens tipada à mão: as funções novas do banco (pegar/soltar pedido
 * para criação) não estão no mapa gerado em `integrations/supabase/types.ts`, e
 * sem isto cada chamada viraria um `as any`.
 */
export const rpcTriagem = supabase.rpc.bind(supabase) as unknown as RpcTriagem;
